<template>
  <div class="plugin-wrapper">
    <template v-if="!isMaster">
      <div class="c-product-carousel__img">
        <picture>
          <source media="(min-width: 1366px)" srcset="@/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-large.png, @/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-large@2x.png 2x">
          <source media="(min-width: 1024px)" srcset="@/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-large.png, @/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-large@2x.png 2x">
          <source media="(min-width: 768px)" srcset="@/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-medium.png, @/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-medium@2x.png 2x">
          <source media="(min-width: 0px)" srcset="@/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background.png, @/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background@2x.png 2x">
          <img class=" lazyloaded" alt="Sisley Paris" srcset="@/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-large@2x.png 2x" src="@/assets/imgs/bg/swiper/hair-rituel/hr-carousel-background-large.png">
        </picture>
      </div>
    </template>
    <div class="plugin-product_swiper layout animatedParent animateOnce">
      <div :class="'carousel swiper' + _uid">
        <swiper class="swiper-x-container"  v-if="list.length > 0" :ref="'pdSwiper' + _uid" :options="swiperOpts">
          <swiper-slide class="swiper-x-item" v-for="(item, index) in list" :key="index">
            <div class="carousel-item">
              <BaseItem :source="item" />
            </div>
          </swiper-slide>
        </swiper>
        <SwiperNavigator v-if="list.length > 3" :xSwiper="pdSwiper" :total="list.length" />
        <!-- <SwiperNavBtns v-if="list.length > 3" :xSwiper="pdSwiper" :direction="direction" mode="bottom" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BaseItem from '@/components/BaseItem';
import SwiperNavigator from '@/components/SwiperNavigator';
// import SwiperNavBtns from '@/components/SwiperNavBtns';
import types from "@/store/types";
import api from "@/utils/api";

let $vm = null;

export default {
  name: "ProductSwiper",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  components: { swiper, swiperSlide, BaseItem, SwiperNavigator },
  data() {
    return {
      pdSwiper: {},
      swiperOpts: {
        loop: true,
        loopedSlides: this.config.nodes.length + 2,
        speed: 1000,
        slidesPerView: 3,
        breakpoints: {
          // 768以下配置
          // 768: {
          //   slidesPerView: 2,
          //   centeredSlides: false,
          //   centeredSlidesBounds: false,
          //   spaceBetween: 0
          // },
          1024: {
            slidesPerView: this.config.nodes.length > 3 ? 1.995 : 2,
            centeredSlides: this.config.nodes.length > 3 ? true : false,
            centeredSlidesBounds: this.config.nodes.length > 3 ? true : false,
            spaceBetween: 0
          }
        },
        navigation: {
          prevEl: `.swiper${this._uid} .carousel__btn--prev`,
          nextEl: `.swiper${this._uid} .carousel__btn--next`
        },
        on: {
          slidePrevTransitionStart() {
            $vm.direction = "prev";
          },
          slidePrevTransitionEnd() {
            $vm.direction = "";
          },
          slideNextTransitionStart() {
            $vm.direction = "next";
          },
          slideNextTransitionEnd() {
            $vm.direction = "";
          }
        }
      },
      direction: "",
      list: []
    };
  },
  computed: {
    isMaster() {
      return this.$store.state.isMaster;
    }
  },
  created() {
    $vm = this;
    let ids = this.config.nodes.map(node => node.product_id).join(",");
    this.loadItems(ids);
  },
  mounted() {},
  methods: {
    loadItems(ids) {
      if (!ids) return false;
      api[types.GOODS_INFO]({ ids: ids }).then(res => {
        if (res.code == 1) {
          this.list = res.data;
          //
          this.$nextTick(() => {
            this.pdSwiper = this.$refs['pdSwiper'+this._uid]?.swiper;
          });
        } else {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .c-product-carousel__img { display: block; position: absolute; z-index: -1; right: 0; bottom: 14.375rem; }

  .carousel-item { padding: 0 .5rem; }
  // 
  .plugin-wrapper {
    position: relative;
    .plugin-product_swiper {
      .carousel {
        position: relative;
        padding: 0;
      }
    }
  }
  @media screen and (min-width: 48em) {
    .carousel-item { padding: 0 .6875rem; }
  }
  @media screen and (min-width: 64em) {
    .c-product-carousel__img { bottom: 15.9375rem; }

    .carousel-item { padding: 0 .5rem; }
    // 
    .plugin-wrapper {
      .plugin-product_swiper {
        .carousel {
          padding: 2.5rem 1.875rem 1.875rem;
        }
      }
    }
  }
  @media screen and (min-width: 75em) {
    .plugin-wrapper {
      .plugin-product_swiper {
        .carousel {
          padding: 0;
        }
      }
    }
  }
</style>